import { Button } from "@/components/ui/button";
import { TwitterMetadata } from "@/types/social-pay.types";
import { ICONS } from "@/components/icons";

interface TwitterSessionExpiredNoticeProps {
  onReconnect: () => void;
  twitterMetadata: TwitterMetadata;
}

export const TwitterSessionExpiredNotice = ({
  onReconnect,
  twitterMetadata,
}: TwitterSessionExpiredNoticeProps) => {
  const { username, name, profilePicture } = twitterMetadata;

  return (
    <div className="w-full relative bg-gradient-to-br from-swapper-primary/5 to-[#9F7FFF]/5 border-2 border-swapper-primary/20 rounded-2xl p-6 md:p-8 shadow-lg">
      <div className="flex flex-col items-center gap-4 md:gap-6">
        {/* Avatar or Icon */}
        {profilePicture ? (
          <div className="relative">
            <img
              src={profilePicture}
              alt={`${name || username}'s profile`}
              className="w-16 h-16 md:w-20 md:h-20 object-cover rounded-full shadow-md"
            />
          </div>
        ) : (
          <div className="relative bg-gradient-to-br from-swapper-primary to-[#9F7FFF] p-5 rounded-2xl shadow-md">
            <img
              src={ICONS.x}
              alt="X (Twitter)"
              width={32}
              height={32}
              className="md:w-10 md:h-10"
              style={{ filter: "invert(1)" }}
            />
          </div>
        )}

        {/* Text content */}
        <div className="text-center space-y-2 md:space-y-3 max-w-sm">
          <h3 className="text-lg md:text-xl font-bold text-swapper-secondary">
            X session expired
          </h3>
          <div className="flex flex-col gap-2">
            <p className="text-sm md:text-base text-swapper-secondary/70 leading-relaxed px-2">
              Your connection with{" "}
              {name && (
                <span className="text-swapper-secondary font-bold">{name}</span>
              )}{" "}
              <span className="font-bold text-swapper-secondary">(@{username})</span>{" "}
              has expired.
            </p>
            <p className="text-sm md:text-base text-swapper-secondary/70 leading-relaxed px-2">
              Please reconnect your X account to complete this task.
            </p>
          </div>
        </div>

        <Button
          onClick={onReconnect}
          className="w-full max-w-sm bg-gradient-to-br from-swapper-primary to-[#9F7FFF] hover:opacity-90 text-white font-semibold rounded-xl px-6 py-3 transition-all duration-200 ease-out hover:shadow-glow text-sm md:text-base"
        >
          <span className="inline-flex items-center justify-center gap-2">
            <img
              src={ICONS.x}
              alt=""
              width={18}
              height={18}
              style={{ filter: "invert(1)" }}
            />
            <span>Reconnect X</span>
          </span>
        </Button>
      </div>
    </div>
  );
};
